var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1956_5273)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66634 1.83301C4.44468 1.83301 1.83301 4.44468 1.83301 7.66634C1.83301 10.888 4.44468 13.4997 7.66634 13.4997C10.888 13.4997 13.4997 10.888 13.4997 7.66634C13.4997 4.44468 10.888 1.83301 7.66634 1.83301ZM0.833008 7.66634C0.833008 3.89239 3.89239 0.833008 7.66634 0.833008C11.4403 0.833008 14.4997 3.89239 14.4997 7.66634C14.4997 9.37334 13.8737 10.9341 12.8389 12.1318L15.0199 14.3128C15.2151 14.5081 15.2151 14.8246 15.0199 15.0199C14.8246 15.2151 14.5081 15.2151 14.3128 15.0199L12.1318 12.8389C10.9341 13.8737 9.37334 14.4997 7.66634 14.4997C3.89239 14.4997 0.833008 11.4403 0.833008 7.66634Z",
    fill: "#535353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1956_5273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.9884c8ee9c9f20abd00c9d333abe9134.svg";
export { ForwardRef as ReactComponent };